import { TextCell } from '@common/components/TextCell';

interface AccountNameCellProps {
	accountName?: string;
}

export const AccountNameCell = ({ accountName }: AccountNameCellProps) => {
	return <TextCell value={accountName} />;
};
